import { useRef } from 'react'
import type { OutputFormat } from '../types'
import type { DropZoneHandle } from '../components/DropZone.tsx'
import Header from '../components/Header.tsx'
import Hero from '../components/Hero.tsx'
import Workspace from '../components/Workspace.tsx'
import Workflow from '../components/Workflow.tsx'
import Boundary from '../components/Boundary.tsx'
import FAQ from '../components/FAQ.tsx'
import Footer from '../components/Footer.tsx'

interface HomeProps {
  preset?: OutputFormat
}

export default function Home({ preset }: HomeProps) {
  const dropZoneRef = useRef<DropZoneHandle>(null)
  const chooseFiles = () => dropZoneRef.current?.chooseFiles()

  return (
    <>
      <Header onChooseFiles={chooseFiles} />
      <main id="top">
        <section className="shell hero" aria-labelledby="hero-title">
          <Hero preset={preset} onChooseFiles={chooseFiles} />
          <Workspace preset={preset ?? 'jpg'} dropZoneRef={dropZoneRef} />
        </section>
        <Workflow />
        <Boundary />
        <FAQ />
      </main>
      <Footer />
    </>
  )
}
